module.exports = __webpack_public_path__ + "static/media/apple_tv_plus_dark.cd584121.svg";